// extracted by mini-css-extract-plugin
export default {"iconButton":"comments_iconButton__ew193","iconCommentBody":"comments_iconCommentBody__6JX27","iconCommentRemove":"comments_iconCommentRemove__DuliJ"};